exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pic_base[data-v-3ecf8887] {\r\n  position: relative;\n}\r\n", ""]);

// exports
